import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './router'

import './assets/main.css'
// Import du CSS de toastify-js pour les notifications
import 'toastify-js/src/toastify.css'

const app = createApp(App)

app.use(createPinia())
app.use(router)

app.mount('#app')
